// CRUD
import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../_base/crud';
import { AppState } from '../reducers';
import {
  selectUsersInStore,
  selectUsersPageLoading,
  selectUsersShowInitWaitingMessage,
} from './user.selectors';

// Selectors

export class UsersDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();
    this.loading$ = this.store.pipe(select(selectUsersPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectUsersShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectUsersInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
